import { render, staticRenderFns } from "./lottie.vue?vue&type=template&id=5cb3c20d&scoped=true&"
import script from "./lottie.vue?vue&type=script&lang=js&"
export * from "./lottie.vue?vue&type=script&lang=js&"
import style0 from "./lottie.vue?vue&type=style&index=0&id=5cb3c20d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3c20d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb3c20d')) {
      api.createRecord('5cb3c20d', component.options)
    } else {
      api.reload('5cb3c20d', component.options)
    }
    module.hot.accept("./lottie.vue?vue&type=template&id=5cb3c20d&scoped=true&", function () {
      api.rerender('5cb3c20d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/animation/lottie.vue"
export default component.exports